// Utilities
import { defineStore } from 'pinia'
import { ref, toRaw } from 'vue'
import { loadTermine, type Termin } from '@/services/termine/terminDataService'

export const useAppStore = defineStore('app', () => {
  const cookies = ref<{ [keys: string]: string }>({})
  const elementSize = ref({
    nav: 0,
    footer: 0
  })
  const termine = ref<Array<Termin>>([])
  const initialized = ref(false)

  // Cookies
  function setCookies(payload: { [keys: string]: string }) {
    cookies.value = payload
  }

  function getCookies(): { [keys: string]: string } {
    return toRaw(cookies.value)
  }

  // Element Size
  function setElementSize(payload: { nav: number; footer: number }) {
    elementSize.value = payload
  }

  function getElementSize(): { nav: number; footer: number } {
    return elementSize.value
  }

  // Initialization
  async function initialize() {
    if (initialized.value) return
    // Load and sort termine by startDate with Zod validation
    const loaded = await loadTermine()
    const parsed = Array.from(loaded)
    parsed.sort((a, b) => {
      const ad = Date.parse(a.startDate)
      const bd = Date.parse(b.startDate)
      return ad - bd
    })
    termine.value = parsed
    initialized.value = true
  }

  // Termine
  function setTermin(termin: Termin) {
    termine.value.push(termin)
  }

  function getTermine(): Array<Termin> {
    return toRaw(termine.value)
  }

  function getTermineByYear(year: number): Array<Termin> {
    return toRaw(termine.value).filter((t) => t.year === year)
  }

  function getTermineYears(): Array<number> {
    const years = new Set<number>()
    for (const t of termine.value) years.add(t.year)
    return Array.from(years).sort((a, b) => a - b)
  }

  return {
    cookies,
    elementSize,
    initialized,
    setCookies,
    getCookies,
    setElementSize,
    getElementSize,
    setTermin,
    getTermine,
    getTermineByYear,
    getTermineYears,
    initialize
  }
})
